// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"4d6c8826","787":"b7659bf8"}[chunkId] + ".chunk.js";
};